import React, { useState } from "react";
import { format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { RANGES } from "@/lib/caseList";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toDate = (s) => (s ? new Date(`${s}T00:00:00`) : undefined);

/** One end of the custom range — a button that opens the calendar. Value is "YYYY-MM-DD". */
const DateBtn = ({ value, onPick, min, max, label, testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="inp added-filter-date" aria-label={label} data-testid={testId}>
          <CalendarDays className="size-3.5" aria-hidden="true" />
          {value ? format(toDate(value), "d MMM yyyy") : label}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={toDate(value)} defaultMonth={toDate(value) || toDate(max) || undefined}
                  disabled={[...(min ? [{ before: toDate(min) }] : []), ...(max ? [{ after: toDate(max) }] : [])]}
                  onSelect={(d) => { onPick(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
                  initialFocus data-testid={`${testId}-calendar`} />
      </PopoverContent>
    </Popover>
  );
};

/** "Added: This week" — the date window a case list shows, with a custom from/to. */
export function AddedFilter({ value, onChange, label = "Added", testId = "added-filter" }) {
  const v = value || { key: "any" };
  const set = (patch) => onChange({ ...v, ...patch });
  return (
    <div className="added-filter" data-testid={testId}>
      <span className="added-filter-l">{label}</span>
      <select className="inp" value={v.key} onChange={(e) => set({ key: e.target.value })} data-testid={`${testId}-range`}
              aria-label={`${label} date range`}>
        {RANGES.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
      </select>
      {v.key === "custom" && (
        <>
          <DateBtn value={v.from} max={v.to} label="From" onPick={(d) => set({ from: d })} testId={`${testId}-from`} />
          <span className="added-filter-to">to</span>
          <DateBtn value={v.to} min={v.from} label="To" onPick={(d) => set({ to: d })} testId={`${testId}-to`} />
        </>
      )}
    </div>
  );
}

export default AddedFilter;
